import React, { useState, useEffect } from "react";

export default function DataAnalysisStudentResponses() {
  const images = [`${process.env.PUBLIC_URL}/Stuent-Response.png`];

  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div className="min-h-screen flex bg-gray-900 text-white">
      {/* Left: Vertical Ribbon */}
      <div className="hidden md:block md:w-1/5 bg-purple-800/30 backdrop-blur-sm" />

      {/* Right: Background Section */}
      <div
        className="relative flex-1 bg-cover bg-center"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/Students-BG.png)`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        <div className="absolute inset-0 bg-black/50 z-0" />

        {/* Floating Card Content */}
        <div className="relative z-10 flex items-center justify-center min-h-screen px-6 sm:px-12 py-20">
          <div className="bg-black/70 backdrop-blur-md rounded-2xl shadow-2xl px-8 sm:px-14 py-12 max-w-6xl w-full">
            <div className="flex flex-col md:flex-row items-stretch gap-y-10 gap-x-16">
              
              {/* Text Section */}
              <div className="flex-1 flex flex-col justify-center space-y-6">
                <h1 className="text-4xl font-bold text-purple-400">
                  Data Analysis of Student Responses
                </h1>
                <p className="text-gray-300 text-lg">
                  Analyzed over 100 student responses to understand how students perceive AI tools like ChatGPT in education.
                </p>
                <ul className="list-disc list-outside pl-6 text-gray-300 leading-relaxed text-lg space-y-4">
                  <li><strong>Data Cleaning:</strong> Refined raw survey data using Pandas for consistent analysis.</li>
                  <li><strong>Pattern Discovery:</strong> Identified sentiment trends using statistical techniques.</li>
                  <li><strong>Visualization:</strong> Created clear, engaging graphs in Python and Excel.</li>
                  <li><strong>Reporting:</strong> Summarized findings on AI effectiveness and adoption trends in education.</li>
                </ul>
                <p className="text-gray-200 text-base">
                  This project revealed how AI is being received by students and highlighted actionable insights to improve digital learning experiences.
                </p>
              </div>

              {/* Image Section */}
              <div className="w-full md:w-1/2 flex justify-center items-stretch">
                <img
                  src={images[currentImage]}
                  alt="Student Response Analysis"
                  className="rounded-xl shadow-lg object-cover w-full h-full"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}